import { Axios } from 'utils'
import { User, Role } from 'types/models'
import { ListResponseType } from './types'

export type ProfileResponse = {
  token_type: string
  status: string
  profile: User
  redirect_to_tou_page: boolean
  current_active_tou_version_id?: number | null
}

export const fetchUserProfile = async (): Promise<ProfileResponse> => {
  try {
    const response = await Axios.post<ProfileResponse>('/auth/me')
    return response.data
  } catch (error) {
    throw error
  }
}

export const getRoles = async () => {
  try {
    const response = await Axios.get<ListResponseType<Role>>('/security/roles')
    return response.data
  } catch (error) {
    throw error
  }
}

export const onLogout = async () => {
  try {
    const response = await Axios.post('/auth/logout')
    return response.data
  } catch (error) {
    throw error
  }
}
